module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "mt-150"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md10": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('p', {
    staticClass: "font-2x mt-7"
  }, [_vm._v(_vm._s(_vm.$t('userRequest.submitRequest')))]), _vm._v(" "), _c('v-form', {
    ref: "userRequestForm",
    model: {
      value: (_vm.userRequestVaild),
      callback: function($$v) {
        _vm.userRequestVaild = $$v
      },
      expression: "userRequestVaild"
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('userRequest.issue'),
      "items": _vm.issueSelect,
      "rules": _vm.issueRules,
      "item-text": "label",
      "item-value": "value",
      "required": ""
    },
    model: {
      value: (_vm.userRequestForm.issue),
      callback: function($$v) {
        _vm.$set(_vm.userRequestForm, "issue", $$v)
      },
      expression: "userRequestForm.issue"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('userRequest.email'),
      "rules": _vm.regEmailRules,
      "hint": _vm.$t('userRequest.emailHint'),
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.userRequestForm.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.userRequestForm, "regEmail", $$v)
      },
      expression: "userRequestForm.regEmail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('userRequest.subject'),
      "rules": _vm.subjectRules,
      "hint": _vm.$t('userRequest.subjectHint'),
      "counter": "50",
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.userRequestForm.subject),
      callback: function($$v) {
        _vm.$set(_vm.userRequestForm, "subject", $$v)
      },
      expression: "userRequestForm.subject"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": _vm.$t('userRequest.description'),
      "rules": _vm.descriptionRules,
      "hint": _vm.$t('userRequest.descriptionHint'),
      "counter": "1000",
      "clearable": "",
      "auto-grow": "",
      "required": ""
    },
    model: {
      value: (_vm.userRequestForm.description),
      callback: function($$v) {
        _vm.$set(_vm.userRequestForm, "description", $$v)
      },
      expression: "userRequestForm.description"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "outline": "",
      "disabled": !_vm.userRequestVaild,
      "loading": _vm.userRequestBtnLoading
    },
    on: {
      "click": _vm.submitRequest
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("common.submit")) + "\n                                ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b4584b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/request/UserRequest.vue
// module id = 453
// module chunks = 0